module.exports = __webpack_public_path__ + "img/j-invicible.1e0fdfc8.png";